export default {
    data: () => ({
        test : "mixin",
        sURLConst : "",
    }),
};
